import React from 'react';
import PropTypes from 'prop-types';

import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';

const MixedGridCardPlaceholder = ({ maxCardsCount = 6 }) => {
  [...Array(maxCardsCount)].map((item, index) => (
    // It is safe to use these indexes as keys because the rendered output of every placeholder item is identical
    // eslint-disable-next-line react/no-array-index-key
    <div className="mixed-grid-item" key={index}>
      <ProductCardStaticPlaceholder />
    </div>
  ));
};

MixedGridCardPlaceholder.propTypes = {
  maxCardsCount: PropTypes.number,
};

export default MixedGridCardPlaceholder;
